export default defineNuxtRouteMiddleware((to) => {
  const partner = localStorage.getItem('partnerName');
  if (!partner) {
    return;
  }

  const pathSegments = to.path.split('/').filter((segment) => segment);
  const uuidRegex =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;

  if (to.path === `/${partner}/accounts/account-statement`) {
    return navigateTo(`/${partner}/wallets/wallet-statement`);
  }

  if (pathSegments.length === 3 && to.path === `/${partner}/my-account/${pathSegments[2]}`) {
    return navigateTo(`/${partner}/my-wallet/overview`);
  }

  if (
    pathSegments.length === 4 &&
    to.path === `/${partner}/accounts/${pathSegments[2]}/${pathSegments[3]}` &&
    !uuidRegex.test(pathSegments[2])
  ) {
    return navigateTo(`/${partner}/wallets/${pathSegments[2]}/overview`);
  }
});
